import { useEffect, useState } from "react";
import { Newspaper } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal, Eyebrow } from "../components/Reveal";
import { CtaBand } from "../components/CtaBand";
import { ActuCard } from "../components/ActuCard";
import { Seo } from "../components/Seo";
import { api } from "../lib/api";

const SLOTS = [1, 2, 3];

const ActuSlot = ({ n }) => (
  <article data-testid={`actu-slot-${n}`} className="bg-white border border-ink/10 h-full flex flex-col">
    <div className="aspect-[16/10] bg-ink grain grid place-items-center">
      <Newspaper className="text-white/25" size={40} />
    </div>
    <div className="p-6 flex flex-col gap-3 flex-1">
      <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-ink/40">Actualité</span>
      <div className="h-5 w-3/4 bg-ink/10" />
      <div className="h-3 w-full bg-ink/5" />
      <div className="h-3 w-5/6 bg-ink/5" />
      <span className="mt-auto pt-4 border-t border-ink/10 text-xs text-ink/40">Emplacement réservé</span>
    </div>
  </article>
);

export default function Actus() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/actus").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  const empty = items && items.length === 0;
  return (
    <div data-testid="actus-page">
      <Seo title="Actus · ENOVA" description="Les actualités d'ENOVA, prestataire informatique B2B à Nouméa." />
      <PageHero eyebrow="Réalisations · Actus" color="#EE8445" title="Actus" />
      <section className="mx-auto max-w-7xl px-5 lg:px-8 py-16 lg:py-24">
        <Eyebrow color="#EE8445">Actus</Eyebrow>
        {empty && <p data-testid="actus-empty" className="mt-6 text-ink/60">Les actualités d'ENOVA seront publiées ici.</p>}
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="actus-grid">
          {empty && SLOTS.map((n, i) => <Reveal key={n} delay={i * 0.06}><ActuSlot n={n} /></Reveal>)}
          {items?.map((a) => <ActuCard key={a.slug} a={a} />)}
        </div>
      </section>
      <CtaBand color="#EE8445" />
    </div>
  );
}
